// extracted by mini-css-extract-plugin
module.exports = {"teacher":"TeacherCell_teacher__1EUio"};